// Third-party
import React from 'react';

// Components
import DatesDisclaimer from './DatesDisclaimer';

// Utils
import { getLipperAsAtDates } from '../../../../utils/disclaimers/comparison';
import { formatMessageWithLocale } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import Locale from '@/types/locale';

interface Props {
  items: ComparisonItem[];
  showItemNames?: boolean;
  locale?: Locale;
}

const LipperLeadersDisclaimer = ({ items, showItemNames, locale }: Props) => (
  <DatesDisclaimer
    globalPrefix={formatMessageWithLocale('Disclaimers.Lipper', locale)}
    itemPrefix={formatMessageWithLocale('Disclaimers.AsAt', locale)}
    itemDates={getLipperAsAtDates(items, locale)}
    showItemNames={showItemNames}
    locale={locale}
  />
);

export default LipperLeadersDisclaimer;
